/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量13
 * @export
 * @interface Col13
 */
export interface Col13 {
}

/**
 * Check if a given object implements the Col13 interface.
 */
export function instanceOfCol13(value: object): value is Col13 {
    return true;
}

export function Col13FromJSON(json: any): Col13 {
    return Col13FromJSONTyped(json, false);
}

export function Col13FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col13 {
    return json;
}

export function Col13ToJSON(json: any): Col13 {
    return Col13ToJSONTyped(json, false);
}

export function Col13ToJSONTyped(value?: Col13 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

